import { useApp } from '@/hooks/use-app-context';
import { DataPolicyHeader } from './DataPolicyHeader';
import { DataPolicySection } from './DataPolicySection';
import { DataPolicyActions } from './DataPolicyActions';

export default function DataPolicy() {
  const { t } = useApp();

  return (
    <div className="mx-auto flex w-full max-w-7xl flex-col gap-8 px-4 pb-12 pt-3 sm:px-6 lg:px-8">
      <DataPolicyHeader />

      <DataPolicySection
        title={t.dataPolicyDataCollection}
        description={t.dataPolicyDataCollectionDesc}
        items={[
          t.dataPolicyObjective1,
          t.dataPolicyObjective2,
          t.dataPolicyObjective3,
          t.dataPolicyObjective4,
        ]}
      />

      <DataPolicySection
        title={t.dataPolicyDataUsage}
        description={t.dataPolicyDataUsageDesc}
        items={[
          t.dataPolicyUsagePoint1,
          t.dataPolicyUsagePoint2,
          t.dataPolicyUsagePoint3,
          t.dataPolicyUsagePoint4,
        ]}
      />

      <DataPolicySection
        title={t.dataPolicyRights}
        description={t.dataPolicyRightsDesc}
        items={[
          t.dataPolicyRightsPoint1,
          t.dataPolicyRightsPoint2,
          t.dataPolicyRightsPoint3,
          t.dataPolicyRightsPoint4,
        ]}
      />

      <DataPolicySection
        title={t.dataPolicyNwuliteLicense}
        description={t.dataPolicyNwuliteLicenseDesc}
        items={[
          t.dataPolicyNwulitePoint1,
          t.dataPolicyNwulitePoint2,
          t.dataPolicyNwulitePoint3,
        ]}
      />

      <DataPolicyActions />
    </div>
  );
}
